import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import Button from '../../common/Button.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
var ArticleDelete = function ArticleDelete(_ref) {
  var articlesAction = _ref.articlesAction;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Delete Article"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    onClick: function onClick() {
      articlesAction({
        formData: {
          articleID: articleID
        },
        method: 'delete'
      });
    },
    style: {
      width: 120
    },
    requireConfirmation: true,
    permission: "edit-pos-articles",
    type: "close"
  }))));
};
var mdtp = {
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(ArticleDelete);